// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"filters-filterContainer-1_xfi7","dropdownLabel":"filters-dropdownLabel-1HBu5b","filterItem":"filters-filterItem-3xkbGc","dropdown":"filters-dropdown-3YnVuX"};